import {
  HttpClient,
  HttpHeaders
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { Configuration } from '../admin-api/configuration';
import { PageableRequest } from '../admin-api/model/pageableRequest';
import { BASE_PATH } from '../admin-api/variables';
import { PageContent } from '../components/table';

export interface SmsOtpErrorItem {
  phoneVerificationId?: number;
  personId?: number | null;
  phone?: string;
  channel?: string;
  email?: string | null;
  lastError?: string;
  attempt?: number;
  createdAt?: string;
  updatedAt?: string;
  expiresAt?: string;
  verifiedAt?: string | null;
  provider?: string;
  verified?: boolean;
}

export interface SmsOtpErrorRequest extends PageableRequest {
  startDate?: Date | string | null;
  endDate?: Date | string | null;
}

export interface ResponseB4ASmsOtpErrorPage {
  result?: PageContent<SmsOtpErrorItem>;
}

@Injectable()
export class SmsOtpErrorService {
  protected basePath = 'http://localhost:8080';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  public listErrors(body: SmsOtpErrorRequest): Observable<ResponseB4ASmsOtpErrorPage> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling listErrors.'
      );
    }

    let headers = this.defaultHeaders;
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }

    const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept([
      '*/*'
    ]);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const httpContentTypeSelected = this.configuration.selectHeaderContentType([
      'application/json'
    ]);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4ASmsOtpErrorPage>(
      'put',
      `${this.basePath}/notifications/sms/errors`,
      {
        body,
        withCredentials: this.configuration.withCredentials,
        headers
      }
    );
  }
}
